namespace Recommendations  {

    export class RecommenderUiHelper {

        constructor(
            private guidService: Core.GuidService,
            private basketService: any,
            private hotelSearch: any,
            private searchUnitService: Search.SearchUnitService,
            private rootPath: Core.RootPath
        )
        {
        }

        getPageSize(windowWidth: number = window.innerWidth): number {
            return windowWidth < 1100 ? 3 : 4;
        }

        toNewTrip(hotel): ng.IPromise<string> {
            const newTab = window.open('recommendations/loading');
            const tripId = this.guidService.uuid();
            return this.basketService
                .createTrip(tripId, Core.Trip.TripType.Hotel)
                .then(({ TripId }) => {
                    this.hotelSearch.buildHotelsRequest({
                        Destination: { Type: 1, Id: hotel.Id },
                        IsFlightPlus: false,
                        TripId
                    }, this.searchUnitService.hotel);
                    return this.hotelSearch.createSearch();
                })
                .then(() => {
                    if(newTab && newTab.location) {
                        newTab.location.href = this.rootPath.getRootPath() +
                            this.basketService.getHotelUrl({ tripId, hotel });
                    }
                });
        }

        bindCarouselEvents($carousel, hotels, trackView): void {
            let listOffset = 0;

            $carousel.off('init');
            $carousel.off('breakpoint');
            $carousel.off('afterChange');

            $carousel.on('init', () => {
                const pageSize = this.getPageSize();
                const items = _.slice(hotels, 0, pageSize);
                trackView(0, 0, pageSize, items);
            });

            // This breakpoint is triggered when resizing the screen beyond a responsive CSS Breakpoint:
            $carousel.on('breakpoint afterChange', (event, slick) => {
                const pageSize = this.getPageSize();
                const currentSlide = getCurrentSlide(slick, pageSize);
                const items = _.slice(hotels, currentSlide, currentSlide + pageSize);
                listOffset = currentSlide;
            });

            function getCurrentSlide(slick, pageSize) {
                //Fix bug where current slide does not take into account
                //that there might not be the full number of items.
                let maxCurrentSlide = _.max([hotels.length - pageSize, 0]);
                return _.min([slick.currentSlide, maxCurrentSlide]);
            }
        }
    }

    angular
        .module('recommendations')
        .service('recommenderUiHelper', RecommenderUiHelper);
}
